/**
 * Generator selector — picks the vendor-specific generator based on cliType.
 * All generator functions are pure; given a wizardStore payload, they return
 * the CLI / XML string ready for download.
 */
import { generateCLIScript as generateFortinetCLI } from "./fortinet";
import { generateZyxelCLIScript as generateZyxelCLI } from "./zyxel";
import { generateWatchGuardCLIScript as generateWatchGuardCLI } from "./watchguard";
import { generatePfSenseXML } from "./pfsense";

export type GeneratorFn = (payload: any) => string;

export function getGenerator(cliType: string): GeneratorFn {
    switch (cliType) {
        case "fortios":
            return generateFortinetCLI as GeneratorFn;
        case "zyxel_zld":
        case "zyxel_uos":
            return generateZyxelCLI as GeneratorFn;
        case "watchguard":
            return generateWatchGuardCLI as GeneratorFn;
        case "pfsense":
            return generatePfSenseXML as GeneratorFn;
        default:
            throw new Error("Unknown cliType: " + cliType);
    }
}

/** Vendor cliType → output filename helper. */
export function getOutputFilename(cliType: string, hostname: string, model: string): string {
    const safe = (hostname || model || "config").replace(/[^a-zA-Z0-9._-]/g, "_");
    switch (cliType) {
        case "pfsense":
            return `${safe}_config.xml`;
        case "fortios":
            return `${safe}_fortios.conf`;
        case "watchguard":
            return `${safe}_fireware.conf`;
        case "zyxel_zld":
        case "zyxel_uos":
            return `${safe}_zyxel.conf`;
        default:
            return `${safe}.txt`;
    }
}

export { generateFortinetCLI, generateZyxelCLI, generateWatchGuardCLI, generatePfSenseXML };
